
import React from 'react';
import AnimateInView from './animate-in-view';
import GoldSectionDivider from './gold-section-divider';

interface SectionHeadingProps {
  title: string;
  subtitle?: string;
  alignment?: 'left' | 'center' | 'right';
  className?: string;
  underlineClassName?: string;
  titleClassName?: string;
  subtitleClassName?: string;
  animation?: 'fade-in' | 'slide-up' | 'scale-in' | 'stagger-children' | 'slide-right' | 'slide-left' | 'blur-in';
  showUnderline?: boolean;
}

const SectionHeading: React.FC<SectionHeadingProps> = ({
  title,
  subtitle,
  alignment = 'left',
  className = '',
  underlineClassName = '',
  titleClassName = '',
  subtitleClassName = '',
  animation = 'fade-in',
  showUnderline = true,
}) => {
  const alignmentClasses = {
    left: 'text-left',
    center: 'text-center mx-auto',
    right: 'text-right ml-auto',
  };

  return (
    <AnimateInView animation={animation} className={`${className}`}>
      {showUnderline && (
        <GoldSectionDivider 
          centered={alignment === 'center'} 
          className={`${alignmentClasses[alignment]} ${underlineClassName}`} 
        />
      )}
      
      <h2 className={`text-forti-fi-DEFAULT mb-3 ${alignmentClasses[alignment]} ${titleClassName}`}>
        {title}
      </h2>
      
      {subtitle && (
        <p className={`text-forti-fi-charcoal/80 mb-8 ${alignmentClasses[alignment]} ${subtitleClassName}`}>
          {subtitle}
        </p>
      )}
    </AnimateInView>
  );
};

export default SectionHeading;
